import React, { useCallback, useContext, useState } from 'react';
import { UserContext } from './UserContext';
import { documentGetCookie, documentSetCookie, stringGetCookie } from '../../cookie';

const PREFERENCES = 'preference';

const defaultPreferences = {
  sideBarLeftSide: false,
  commentsUnderVideo: false,
  nsfwActive: true,
  landscape: true,
  highlightedItems: true,
  detailsPageMobileBlock: 'comments',
  stickyVideoMobile: true,
  upNextActive: false,
  theme: 'dark',
  filter: '',
  listType: {
    detailsPage: 'latest',
  },
  sorting: {
    comments: 'Datum nieuw',
    search: 'date',
  },
};

export const getPreferenceCookie = (str) => {
  const preference = str ? stringGetCookie(PREFERENCES, str) : documentGetCookie(PREFERENCES);
  if (preference) {
    try {
      return JSON.parse(preference);
    } catch (e) {
      /* no-op */
    }
  }

  return defaultPreferences;
};

export const updateTheme = (theme = 'dark') => {
  const classlist = document.body.classList;
  if (theme === 'dark') {
    classlist.remove('light');
    classlist.add('dark');
  } else {
    classlist.remove('dark');
    classlist.add('light');
  }
};

export const PreferenceContext = React.createContext({});
PreferenceContext.displayName = 'Preference';

export const PreferenceContextProvider = ({ children, staticContext }) => {
  const { request } = staticContext || {};
  const { user } = useContext(UserContext);
  const [preference, setPreference] = useState(
    getPreferenceCookie(request ? request.headers.cookie : null),
  );

  const setPreferencePersistent = useCallback(
    (p) => {
      setPreference((currentPreference) => {
        if (p && p.theme && currentPreference.theme !== p.theme) {
          updateTheme(p.theme);
        }
        const newPreference = { ...currentPreference, ...p };
        if (newPreference.sorting.comments === 'Moderator view' && user === null) {
          newPreference.sorting.comments = 'Datum nieuw';
        }
        documentSetCookie('preference', JSON.stringify(newPreference));
        return newPreference;
      });
    },
    [user, setPreference],
  );

  return (
    <PreferenceContext.Provider value={{ preference, setPreference: setPreferencePersistent }}>
      {children}
    </PreferenceContext.Provider>
  );
};
